<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import WebsitesTable from './WebsitesTable';

export default {
  page: {
    title: 'Websites',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, WebsitesTable },
  data() {
    return {
      title: 'Websites',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Websites', active: true, },
      ],
      
      loading: true,
    }
  },
  created() {

  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <WebsitesTable ref="WebsitesTable" @loadchange="(e) => {loading = e;}"></WebsitesTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
